import { Injectable } from '@angular/core';

import { BaseHttpService } from 'shared/base/_base-http.service';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { catchError } from 'rxjs/operators';
import { contentHeaders } from 'common/headers';


@Injectable()
export class CustomFieldsService extends BaseHttpService {

  getCustomFields(brandId: any, status: string): Observable<any> {
    return this.http.get(`${Config.API}/custom-fields-list/${brandId}/${status}`)
        .pipe(catchError(this.handleError.bind(this)));
  }

  postCustomFields(brandId: any, status: string, itemIds: Array<number>): Observable<any> {
    const body = JSON.stringify({ itemIds });
    return this.http.post(
      `${Config.API}/custom-fields-list/${brandId}/${status}`,
      body,
      {headers: contentHeaders})
        .pipe(catchError(this.handleError.bind(this)));
  }
}
